// src/PrivacyPolicy.jsx
export default function PrivacyPolicy() {
  return (
    <div style={{maxWidth: 800, margin: "40px auto", padding: 24}}>
      <h1>Privacy Policy</h1>
      <p>
        <strong>Last updated: June 2025</strong>
      </p>
      <p>
        Thank you for using our app. Your privacy is extremely important to us. This policy explains what personal data we collect, how we use it, and how you can contact us with questions or requests.
      </p>

      <h2>Audio Data & GDPR</h2>
      <p>
        <strong>We never keep your voice. We never use your data for anything else.</strong><br/>
        When you record or upload audio for analysis, your audio is processed instantly and <strong>never stored</strong> on our servers. We do not retain, save, or share your recordings for any purpose. This approach ensures full compliance with the EU General Data Protection Regulation (GDPR) and reflects our commitment to privacy and German data protection values.
      </p>

      <h2>What data do we collect?</h2>
      <ul>
        <li>
          <strong>Account Information:</strong> When you sign up, we collect your email address and (if provided) your display name or username.
        </li>
        <li>
          <strong>Social Login:</strong> If you sign in with Google or Facebook, we may receive your name, email address, and profile picture from those services.
        </li>
        <li>
          <strong>Usage Data:</strong> We may collect anonymous data about how you use the app to help us improve our services. This may include device type, browser, and usage patterns.
        </li>
      </ul>

      <h2>How do we use your data?</h2>
      <ul>
        <li>To create and manage your account.</li>
        <li>To provide the app’s features and personalize your experience.</li>
        <li>To communicate with you if needed (for example, password resets).</li>
        <li>To improve our app and fix bugs.</li>
      </ul>

      <h2>How do we store and protect your data?</h2>
      <ul>
        <li>Your data is securely stored using Firebase Authentication and related services.</li>
        <li>We do not sell your personal data to third parties.</li>
        <li>We take reasonable steps to protect your information from unauthorized access.</li>
        <li>
          <strong>Audio data is never stored or retained.</strong> All audio is processed in-memory and deleted immediately after analysis.
        </li>
      </ul>

      <h2>Who can access your data?</h2>
      <ul>
        <li>
          Only the app’s developer and trusted service providers (such as Firebase and Vercel) can access your data as needed to operate the app.
        </li>
      </ul>

      <h2>Your rights under GDPR</h2>
      <ul>
        <li>You have the right to access, correct, or delete your personal data at any time.</li>
        <li>You may request a copy of your data or ask for your account to be deleted by contacting us.</li>
        <li>You have the right to complain to a data protection authority if you believe your rights are violated.</li>
      </ul>

      <h2>How can you delete your data?</h2>
      <ul>
        <li>
          You can request deletion of your account and personal data at any time by emailing us at <a href="mailto:nnofficial2414@gmail.com">nnofficial2414@gmail.com</a>.
        </li>
      </ul>

      <h2>Contact</h2>
      <p>
        If you have any questions or concerns about your privacy, please contact us at <a href="mailto:nnofficial2414@gmail.com">nnofficial2414@gmail.com</a>.
      </p>

      <h2>Hosting & Third Parties</h2>
      <p>
        This app is hosted on Vercel. You can read <a href="https://vercel.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">Vercel’s Privacy Policy here</a>.
      </p>
    </div>
  );
}
